module.exports = __webpack_public_path__ + "static/media/arrow-dropdown.c44b26ba.svg";